function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 11C2 10.4477 2.44772 10 3 10L21 10C21.5523 10 22 10.4477 22 11C22 11.5523 21.5523 12 21 12L3 12C2.44772 12 2 11.5523 2 11Z",
  fill: "#8C8DA0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 5C2 4.44772 2.44772 4 3 4L21 4C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6L3 6C2.44772 6 2 5.55228 2 5Z",
  fill: "#8C8DA0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 17C2 16.4477 2.26863 16 2.6 16L13.4 16C13.7314 16 14 16.4477 14 17C14 17.5523 13.7314 18 13.4 18L2.6 18C2.26863 18 2 17.5523 2 17Z",
  fill: "#8C8DA0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.1938 14.1937C15.9355 14.452 15.9355 14.8708 16.1938 15.1292L18.0648 17.0001L16.1937 18.8712C15.9354 19.1295 15.9354 19.5483 16.1937 19.8066C16.452 20.0649 16.8708 20.0649 17.1292 19.8066L19.0002 17.9355L20.8709 19.8063C21.1292 20.0646 21.548 20.0646 21.8064 19.8063C22.0647 19.5479 22.0647 19.1291 21.8064 18.8708L19.9356 17.0001L21.8063 15.1295C22.0646 14.8712 22.0646 14.4524 21.8063 14.1941C21.5479 13.9358 21.1291 13.9358 20.8708 14.1941L19.0002 16.0647L17.1293 14.1937C16.8709 13.9354 16.4521 13.9354 16.1938 14.1937Z",
  fill: "#8C8DA0"
});

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.57ce4c2f.svg";
export { ForwardRef as ReactComponent };